import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.scss';


const Pin = ({ children, className, ...props }) => (
  <div
    className={classNames('pin', className)}
    styleName='pin'
    {...props}
  >

    { children }

  </div>
);

Pin.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Pin.defaultProps = {
  children: null,
  className: null,
};

export default Pin;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/MapMarker/Pin.jsx